import { useState } from 'react'

import { cx } from '@linaria/core'
import { useErrorBoundary } from 'react-error-boundary'

import { userFollowUser, userUnfollowUser } from '~/api-client/food_api/user'
import { User } from '~/api-definition/definition'
import { Button } from '~/components/action/Button'
import { Modal } from '~/components/action/Modal'
import { UserPlusIcon, UsersIcon } from '~/components/icons'
import { useSession } from '~/provider/SessionProvider'

export const UserFollowLargeButton: React.FC<{
  user: User
  showFollowingStatusSymbol?: boolean
  onChangeFollowingStatus: () => Promise<void>
}> = (props) => {
  const session = useSession()
  const accessToken = session.response?.data.accessToken
  const { showBoundary } = useErrorBoundary()

  const [isLoading, setIsLoading] = useState(false)

  const [unfollowModal, setUnfollowModal] = useState(false)

  return (
    <>
      <Modal
        isOpen={unfollowModal}
        title={`${props.user.displayName}さんのフォロー解除してもよろしいですか？`}
        actionButtons={
          <div className="grid grid-cols-2 mt-4 gap-x-4">
            <Button
              type="button"
              variant="functionWeak"
              shrink
              onClick={async (e) => {
                e.stopPropagation()

                setUnfollowModal(false)
              }}
            >
              キャンセル
            </Button>
            <Button
              type="button"
              variant="primary"
              shrink
              onClick={async (e) => {
                e.stopPropagation()

                if (isLoading) return
                setIsLoading(true)
                try {
                  if (accessToken) {
                    await userUnfollowUser({
                      accessToken,
                      searchParams: {
                        user_id: props.user.userId,
                      },
                    })
                    await props.onChangeFollowingStatus()
                  }
                } catch (e) {
                  showBoundary(e)
                } finally {
                  setUnfollowModal(false)
                  setIsLoading(false)
                }
              }}
            >
              解除する
            </Button>
          </div>
        }
      />
      <Button
        type="button"
        variant={props.user.following ? 'functionWeak' : 'navy'}
        className={cx(
          'text-sm px-2 py-1 border border-[#E6E6EA] flex items-center space-x-2 rounded-md whitespace-nowrap'
        )}
        onClick={async (e) => {
          e.preventDefault()
          e.stopPropagation()

          if (isLoading) return

          setIsLoading(true)
          try {
            if (accessToken) {
              if (props.user.following) {
                setUnfollowModal(true)
                setIsLoading(false)
              } else {
                await userFollowUser({
                  accessToken,
                  body: {
                    user_id: props.user.userId,
                  },
                })
                await props.onChangeFollowingStatus()
                setIsLoading(false)
              }
            }
          } catch (e) {
            showBoundary(e)
          }
        }}
      >
        {props.user.following && (
          <>
            <UsersIcon className="h-6 w-6 fill-black" />
            フォロー中
          </>
        )}
        {!props.user.following && (
          <>
            <UserPlusIcon className="fill-white h-6 w-6" />
            フォロー
          </>
        )}
      </Button>
    </>
  )
}
